define.alias("shared/components/shared/social/refresh-profile/threads", "settings/components/shared/social/refresh-profile/threads");